import { StickyNavigationData } from '../../types/optimizely/blocks/stickyNavigation';
import { FrontPage } from '../../types/optimizely/frontpage';

export const useStickyNavigationData = (
	props: FrontPage | null,
): StickyNavigationData | null => {
	if (props) {
		return {
			fontColor: props.fontColor.value,
			backgroundColor: props.backgroundColor.value,
			blocksData: props.stickyNavigationElements?.expandedValue?.map(
				(stickyNavigationElement) => ({
					id: stickyNavigationElement?.targetBlock?.value.id.toString() ?? '',
					title: stickyNavigationElement.title.value,
				}),
			),
		};
	}
	return null;
};
